import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/index.css'

// Применяем тему до рендера, чтобы страница входа (без Layout) тоже была с правильными стилями
const savedTheme = localStorage.getItem('admin_theme')
document.documentElement.dataset.theme =
  savedTheme === 'light' || savedTheme === 'dark' ? savedTheme : 'dark'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
